import { render, staticRenderFns } from "./popupuniversal.vue?vue&type=template&id=9385b876"
import script from "./popupuniversal.vue?vue&type=script&lang=js"
export * from "./popupuniversal.vue?vue&type=script&lang=js"
import style0 from "./popupuniversal.vue?vue&type=style&index=0&id=9385b876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports